<div [ngSwitch]="view" class="views">

    <chat-contact-sidenav class="view" *ngSwitchCase="'contact'" [@slideInRight] fusePerfectScrollbar>
    </chat-contact-sidenav>

</div>